import { number, string } from 'prop-types';
import { useIntl } from 'react-intl';

import { toCurrency } from 'utils/number';

import { Container, Title, Total, Description } from './styles';

function GraphReference({ type, total }) {
  const intl = useIntl();

  return (
    <Container type={type}>
      <Title>{intl.formatMessage({ id: `forecasting.graph.${type}` })}</Title>
      <Total>{toCurrency(total)}</Total>
      <Description>
        {intl.formatMessage({ id: `forecasting.graph.${type}Description` })}
      </Description>
    </Container>
  );
}

GraphReference.propTypes = {
  type: string,
  total: number
};

export default GraphReference;
